import { useCallback } from 'react'
import { VersionReportVersionPageFormModel } from '../../../model/VersionReportVersionPageFormModel'

export const usePageConfigHandlers = (
  page: VersionReportVersionPageFormModel,
  onUpdate: (
    pageNumber: number,
    updater: (
      prev: VersionReportVersionPageFormModel
    ) => VersionReportVersionPageFormModel
  ) => void
) => {
  const handlePageTitleChange = useCallback(
    (e: React.ChangeEvent<HTMLInputElement>) => {
      onUpdate(page.pageNumber, prev => ({
        ...prev,
        pageTitle: e.target.value,
      }))
    },
    [page.pageNumber, onUpdate]
  )

  // どのページ種別の設定も tableRows を持つので、種別ごとに書き分けない
  const handleTableRowsChange = useCallback(
    (uuids: string[]) => {
      onUpdate(page.pageNumber, prev => ({
        ...prev,
        config: { ...prev.config, tableRows: uuids },
      }))
    },
    [page.pageNumber, onUpdate]
  )

  return {
    handlePageTitleChange,
    handleTableRowsChange,
  }
}
